import { Check, Minus } from "lucide-react";

const YELLOW = "#F7C948";
export const PLAN_PRICES = { free: 0, starter: 39, voice: 59, autopilot: 129 };

const T = {
  ru: {
    cols: ["Free", "Starter", "Voice", "Autopilot"],
    sub: ["CRM бесплатно навсегда", "ИИ в чатах", "ИИ на телефоне", "Всё вместе"],
    popular: "Выгодно", perMonth: "/мес", cta: ["Начать бесплатно", "Попробовать", "Подключить", "Подключить всё"],
    rows: [
      ["Календарь, онлайн-запись, мини-сайт", true, true, true, true],
      ["База клиентов и история визитов", true, true, true, true],
      ["ИИ отвечает в чатах (сайт, WhatsApp, Instagram)", false, "1 канал · 100 диалогов", false, "все каналы · 1000 диалогов"],
      ["ИИ отвечает по телефону (свой номер)", false, false, "150 минут", "150 минут"],
      ["Напоминания клиентам", "email", "WhatsApp / Instagram", "звонком", "WhatsApp → звонок"],
      ["Узнаёт постоянных клиентов по имени", false, "в чате", "по телефону", "везде"],
      ["Голосовые ответы в WhatsApp / Instagram", false, false, false, true],
      ["Возврат «спящих» клиентов", false, false, false, true],
      ["Аналитика и отчёты", "базовая", "по диалогам", "по звонкам", "полная"],
      ["Поддержка", "чат", "чат", "приоритет", "приоритет + онбординг"],
    ],
    addonsTitle: "Дополнительно",
    addons: [["ИИ на телефоне для подписчиков Starter", "€30/мес (вместо €59)"], ["Доп. канал (WhatsApp или Instagram)", "€19/мес"], ["+100 диалогов", "€10"], ["+100 минут телефона (или 50 исходящих)", "€19"], ["Доп. филиал", "50% от тарифа: Starter €19.5 · Voice €29.5 · Autopilot €64.5"], ["Доп. номер телефона", "€15/мес"]],
    yearly: "При оплате за год — 2 месяца в подарок (−17%)",
  },
  en: {
    cols: ["Free", "Starter", "Voice", "Autopilot"],
    sub: ["CRM free forever", "AI in chats", "AI on the phone", "Everything"],
    popular: "Best value", perMonth: "/mo", cta: ["Start for free", "Try it", "Get Voice", "Get everything"],
    rows: [
      ["Calendar, online booking, mini-site", true, true, true, true],
      ["Client base & visit history", true, true, true, true],
      ["AI replies in chats (website, WhatsApp, Instagram)", false, "1 channel · 100 conversations", false, "all channels · 1000 conversations"],
      ["AI answers the phone (own number)", false, false, "150 minutes", "150 minutes"],
      ["Client reminders", "email", "WhatsApp / Instagram", "by call", "WhatsApp → call"],
      ["Recognises returning clients by name", false, "in chat", "on the phone", "everywhere"],
      ["Voice replies in WhatsApp / Instagram", false, false, false, true],
      ["Win back inactive clients", false, false, false, true],
      ["Analytics & reports", "basic", "conversations", "calls", "full"],
      ["Support", "chat", "chat", "priority", "priority + onboarding"],
    ],
    addonsTitle: "Add-ons",
    addons: [["Phone AI for Starter subscribers", "€30/mo (instead of €59)"], ["Extra channel (WhatsApp or Instagram)", "€19/mo"], ["+100 conversations", "€10"], ["+100 phone minutes (or 50 outbound)", "€19"], ["Extra location", "50% of plan: Starter €19.5 · Voice €29.5 · Autopilot €64.5"], ["Extra phone number", "€15/mo"]],
    yearly: "Pay yearly — 2 months free (−17%)",
  },
  fr: {
    cols: ["Free", "Starter", "Voice", "Autopilot"],
    sub: ["CRM gratuit à vie", "IA dans les chats", "IA au téléphone", "Tout inclus"],
    popular: "Meilleure offre", perMonth: "/mois", cta: ["Commencer gratuitement", "Essayer", "Activer Voice", "Tout activer"],
    rows: [
      ["Agenda, réservation en ligne, mini-site", true, true, true, true],
      ["Base clients et historique", true, true, true, true],
      ["L'IA répond dans les chats (site, WhatsApp, Instagram)", false, "1 canal · 100 conversations", false, "tous les canaux · 1000 conversations"],
      ["L'IA répond au téléphone (numéro dédié)", false, false, "150 minutes", "150 minutes"],
      ["Rappels clients", "email", "WhatsApp / Instagram", "par appel", "WhatsApp → appel"],
      ["Reconnaît les clients fidèles par leur prénom", false, "dans le chat", "au téléphone", "partout"],
      ["Réponses vocales WhatsApp / Instagram", false, false, false, true],
      ["Relance des clients inactifs", false, false, false, true],
      ["Statistiques et rapports", "basiques", "conversations", "appels", "complètes"],
      ["Support", "chat", "chat", "prioritaire", "prioritaire + onboarding"],
    ],
    addonsTitle: "Options",
    addons: [["IA téléphone pour les abonnés Starter", "30 €/mois (au lieu de 59 €)"], ["Canal supplémentaire (WhatsApp ou Instagram)", "19 €/mois"], ["+100 conversations", "10 €"], ["+100 minutes (ou 50 sortantes)", "19 €"], ["Établissement supplémentaire", "50 % du tarif : Starter 19,5 € · Voice 29,5 € · Autopilot 64,5 €"], ["Numéro supplémentaire", "15 €/mois"]],
    yearly: "Paiement annuel — 2 mois offerts (−17 %)",
  },
  tr: {
    cols: ["Free", "Starter", "Voice", "Autopilot"],
    sub: ["CRM sonsuza dek ücretsiz", "Sohbetlerde AI", "Telefonda AI", "Hepsi bir arada"],
    popular: "En avantajlı", perMonth: "/ay", cta: ["Ücretsiz başla", "Dene", "Voice'u aç", "Hepsini aç"],
    rows: [
      ["Takvim, online randevu, mini site", true, true, true, true],
      ["Müşteri tabanı ve ziyaret geçmişi", true, true, true, true],
      ["AI sohbetlerde yanıtlar (site, WhatsApp, Instagram)", false, "1 kanal · 100 diyalog", false, "tüm kanallar · 1000 diyalog"],
      ["AI telefona yanıt verir (kendi numaranız)", false, false, "150 dakika", "150 dakika"],
      ["Müşteri hatırlatmaları", "e-posta", "WhatsApp / Instagram", "arayarak", "WhatsApp → arama"],
      ["Sadık müşterileri adıyla tanır", false, "sohbette", "telefonda", "her yerde"],
      ["WhatsApp / Instagram sesli yanıtlar", false, false, false, true],
      ["Pasif müşterileri geri kazanma", false, false, false, true],
      ["Analitik ve raporlar", "temel", "diyaloglar", "aramalar", "tam"],
      ["Destek", "sohbet", "sohbet", "öncelikli", "öncelikli + kurulum"],
    ],
    addonsTitle: "Ek hizmetler",
    addons: [["Starter aboneleri için telefon AI", "€30/ay (€59 yerine)"], ["Ek kanal (WhatsApp veya Instagram)", "€19/ay"], ["+100 diyalog", "€10"], ["+100 telefon dakikası (veya 50 giden)", "€19"], ["Ek şube", "tarifenin %50'si: Starter €19.5 · Voice €29.5 · Autopilot €64.5"], ["Ek telefon numarası", "€15/ay"]],
    yearly: "Yıllık ödemede 2 ay hediye (−%17)",
  },
};

const Cell = ({ v, hi }) => {
  if (v === true) return <Check className="w-5 h-5 mx-auto" strokeWidth={2.75} style={{ color: hi ? YELLOW : "#17150F" }} />;
  if (v === false) return <Minus className="w-4 h-4 mx-auto opacity-30" />;
  return <span className={`text-[12.5px] font-semibold leading-tight ${hi ? "text-white" : "text-[#3a3480]"}`}>{v}</span>;
};

export default function PricingTable({ lang, onStart }) {
  const L = T[lang] || T.en;
  const keys = ["free", "starter", "voice", "autopilot"];
  return (
    <div data-testid="pricing-table">
      <div className="overflow-x-auto -mx-5 px-5 lg:mx-0 lg:px-0 pt-4 pb-2">
        <table className="w-full min-w-[760px] border-separate" style={{ borderSpacing: 0 }}>
          <thead>
            <tr>
              <th className="text-left align-bottom pb-4 pr-4 w-[30%] sticky left-0 z-10" style={{ background: "#F5F1E8" }} />
              {keys.map((k, i) => {
                const hi = k === "autopilot";
                return (
                  <th key={k} className={`align-bottom p-0 ${hi ? "" : ""}`} data-testid={`plan-${k}`}>
                    <div className={`mx-1.5 rounded-t-2xl px-4 pt-5 pb-4 text-center relative ${hi ? "text-white" : "bg-white"}`} style={hi ? { background: "#131210" } : {}}>
                      {hi && <span className="absolute -top-3 left-1/2 -translate-x-1/2 text-[11px] font-bold px-3 py-1 rounded-full text-[#17150F]" style={{ background: YELLOW }}>{L.popular}</span>}
                      <div className="font-extrabold text-[18px]">{L.cols[i]}</div>
                      <div className={`text-[12px] mt-0.5 ${hi ? "text-[#9b968a]" : "text-[#57534a]"}`}>{L.sub[i]}</div>
                      <div className="mt-3 flex items-baseline justify-center gap-1">
                        <span className="text-[34px] font-extrabold leading-none">€{PLAN_PRICES[k]}</span>
                        <span className={`text-[13px] ${hi ? "text-[#9b968a]" : "text-[#8a8577]"}`}>{L.perMonth}</span>
                      </div>
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {L.rows.map((r, ri) => (
              <tr key={ri} data-testid={`pricing-row-${ri}`}>
                <td className="text-[14px] font-medium py-3 pr-4 border-t border-[#e6e1d6] sticky left-0 z-10 max-w-[150px] sm:max-w-none" style={{ background: "#F5F1E8" }}>{r[0]}</td>
                {keys.map((k, ci) => {
                  const hi = k === "autopilot";
                  return (
                    <td key={k} className="p-0">
                      <div className={`mx-1.5 h-full px-3 py-3 text-center border-t ${hi ? "border-[#2a2824]" : "bg-white border-[#efebe2]"}`} style={hi ? { background: "#131210" } : {}}>
                        <Cell v={r[ci + 1]} hi={hi} />
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
            <tr>
              <td className="border-t border-[#e6e1d6] sticky left-0 z-10" style={{ background: "#F5F1E8" }} />
              {keys.map((k, i) => {
                const hi = k === "autopilot";
                return (
                  <td key={k} className="p-0">
                    <div className={`mx-1.5 rounded-b-2xl px-3 pt-4 pb-5 ${hi ? "" : "bg-white"}`} style={hi ? { background: "#131210" } : {}}>
                      <button onClick={onStart} data-testid={`plan-${k}-cta`}
                        className={`w-full font-bold text-[13.5px] py-2.5 rounded-xl transition-all ${hi ? "text-[#17150F] hover:scale-[1.02]" : "border-2 border-[#17150F] hover:bg-black hover:text-white"}`}
                        style={hi ? { background: YELLOW } : {}}>{L.cta[i]}</button>
                    </div>
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>

      <div className="mt-8 bg-white/70 rounded-2xl p-5 lg:p-6" data-testid="pricing-addons">
        <div className="text-[11px] font-bold tracking-[0.16em] text-[#8a8577]">{L.addonsTitle.toUpperCase()}</div>
        <div className="mt-3 grid sm:grid-cols-2 gap-x-8 gap-y-2">
          {L.addons.map(([n, p], i) => (
            <div key={i} className="flex items-baseline justify-between gap-3 text-[13.5px] border-b border-dashed border-[#e6e1d6] py-1.5">
              <span>{n}</span><span className="font-bold text-right max-w-[55%] leading-snug">{p}</span>
            </div>
          ))}
        </div>
        <div className="text-[12px] text-[#8a8577] mt-4">{L.yearly}</div>
      </div>
    </div>
  );
}
